import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ThemeRequest } from '../theme.model';

export const THEME_FEATURE = 'cx-theme';
export const themeSelector = createSelector(createFeatureSelector<ThemeRequest>(THEME_FEATURE), state => state);
